/* eslint-disable max-len */
import { ScalpSeverityLanguageCopy } from '../services/concern-detections-service/concern-detections.constants';

export const scalpSeverityCopy: { [language: string]: ScalpSeverityLanguageCopy } = {
  en: {
    titles: {
      Normal: 'No signs of hair loss',
      Mild: 'Early-stage hair loss',
      Moderate: 'Moderate hair loss',
      Severe: 'Advanced hair loss',
      Unknown: 'Scalp Visibility Detected',
    },
    parameterLabels: {
      crownDensity: 'Crown Density',
      partitionWidth: 'Partition Width',
      scalpVisibility: 'Scalp Visibility',
    },
    descriptions: {
      Female: {
        Normal: 'You have healthy hair density, with no visible scalp or thinning. This is the easiest time to protect it — the right hair care routine can help keep it this way for years.',
        Mild: 'You have slight widening along the partition — the first sign of thinning. At this stage, hair fall is easiest to reverse. Start treatment now!',
        Moderate: 'You have noticeable widening along the partition, extending towards the hairline and crown. Start treatment now to stop it going further.',
        Severe: 'You have significant scalp visibility across the partition and crown. This stage is harder to reverse, but consistent treatment can still slow it.',
        Unknown: 'You have visible scalp area along your partition — a sign of hair thinning. This stage can progress soon without treatment. Start now to stop it!',
      },
      Male: {
        Normal: 'You have healthy density at the crown and hairline, with no visible scalp or thinning. This is the easiest time to protect it — the right hair care routine can help keep it this way for years.',
        Mild: 'You have slight thinning at the crown — an early sign of hair loss. At this stage, hair fall is easiest to reverse. Start treatment now!',
        Moderate: 'You have noticeable thinning at the crown, extending towards the hairline. Start treatment now to stop it going further.',
        Severe: 'You have significant scalp visibility across the crown and hairline. This stage is harder to reverse, but consistent treatment can still slow it.',
        Unknown: 'You have visible scalp area at the crown and in front — a sign of hair loss. This stage can progress soon without treatment. Start now to stop it!',
      },
    },
    noDetection: {
      title: "Couldn't detect your scalp",
      reasonsHeading: 'Possible reasons:',
      reasons: [
        'Top of head not fully visible in frame',
        'Photo is blurry or unclear',
        'Lighting is too low or too bright',
      ],
    },
    hairFrontDetected: {
      title: 'Hair front captured',
      description: 'We received a front-view photo. Please retake with a top-view of your scalp for the scalp assessment.',
    },
  },
  hi: {
    titles: {
      Normal: 'अभी बाल झड़ने के कोई संकेत नहीं हैं',
      Mild: 'शुरुआती हेयर लॉस के संकेत मिले',
      Moderate: 'स्कैल्प ज़्यादा दिखाई दे रहा है',
      Severe: 'बढ़ा हुआ हेयर लॉस',
      Unknown: 'स्कैल्प दिखाई दे रहा है',
    },
    parameterLabels: {
      crownDensity: 'क्राउन डेंसिटी',
      partitionWidth: 'मांग की चौड़ाई',
      scalpVisibility: 'स्कैल्प विज़िबिलिटी',
    },
    descriptions: {
      Female: {
        Normal: 'आपके बालों की घनत्व अच्छी है, सिर की त्वचा दिखाई नहीं दे रही और बाल पतले होने के संकेत भी नहीं हैं। इन्हें स्वस्थ बनाए रखने का यह सबसे अच्छा समय है — सही हेयर केयर रूटीन आपके बालों को सालों तक ऐसा बनाए रखने में मदद कर सकता है।',
        Mild: 'आपकी मांग थोड़ी चौड़ी हो रही है — यह बाल पतले होने का शुरुआती संकेत है। इस स्टेज पर बालों का झड़ना रोकना और सुधारना सबसे आसान है। अभी ट्रीटमेंट शुरू करें!',
        Moderate: 'आपकी मांग काफी चौड़ी हो रही है और यह हेयरलाइन और सिर के ऊपरी हिस्से की ओर बढ़ रही है। इसे और बढ़ने से रोकने के लिए अभी ट्रीटमेंट शुरू करें।',
        Severe: 'मांग और सिर के ऊपरी हिस्से में सिर की त्वचा काफी दिखाई दे रही है। इस स्टेज पर सुधार थोड़ा मुश्किल है, लेकिन नियमित ट्रीटमेंट इसे और बढ़ने से धीमा कर सकता है।',
        Unknown: 'आपकी मांग के आसपास सिर की त्वचा दिखाई दे रही है — यह बाल पतले होने का संकेत है। बिना ट्रीटमेंट के यह जल्दी बढ़ सकता है। इसे रोकने के लिए अभी ट्रीटमेंट शुरू करें!',
      },
      Male: {
        Normal: 'सिर के ऊपरी हिस्से और हेयरलाइन पर बालों की घनत्व अच्छी है। सिर की त्वचा दिखाई नहीं दे रही और बाल पतले होने के संकेत भी नहीं हैं। सही हेयर केयर रूटीन आपके बालों को सालों तक ऐसा बनाए रखने में मदद कर सकता है।',
        Mild: 'सिर के ऊपरी हिस्से पर हल्का पतलापन दिख रहा है — यह बाल झड़ने का शुरुआती संकेत है। इस स्टेज पर सुधार सबसे आसान है। अभी ट्रीटमेंट शुरू करें!',
        Moderate: 'सिर के ऊपरी हिस्से का पतलापन अब हेयरलाइन तक बढ़ रहा है। इसे और बढ़ने से रोकने के लिए अभी ट्रीटमेंट शुरू करें।',
        Severe: 'सिर के ऊपरी हिस्से और हेयरलाइन पर सिर की त्वचा साफ़ दिखाई दे रही है। इस स्टेज पर सुधार थोड़ा मुश्किल है, लेकिन नियमित ट्रीटमेंट इसे बढ़ने से धीमा कर सकता है।',
        Unknown: 'सिर के ऊपरी हिस्से और सामने सिर की त्वचा दिखाई दे रही है — यह बाल झड़ने का संकेत है। बिना ट्रीटमेंट के यह जल्दी बढ़ सकता है। इसे रोकने के लिए अभी ट्रीटमेंट शुरू करें!',
      },
    },
    noDetection: {
      title: 'स्कैल्प का सही आकलन नहीं हो सका',
      reasonsHeading: 'संभावित कारण:',
      reasons: [
        'सिर का ऊपरी हिस्सा पूरी तरह फोटो में नहीं है',
        'फोटो धुंधली या साफ़ नहीं है',
        'रोशनी बहुत कम या बहुत ज़्यादा है',
      ],
    },
    hairFrontDetected: {
      title: 'बालों का सामने का दृश्य मिला',
      description: 'हमें सामने से ली गई फोटो मिली है। स्कैल्प के आकलन के लिए कृपया अपने सिर के ऊपरी हिस्से का दृश्य देते हुए फोटो दोबारा लें।',
    },
  },
  mr: {
    titles: {
      Normal: 'अजून केसगळतीची चिन्हे नाहीत',
      Mild: 'सुरुवातीच्या केसगळतीची चिन्हे दिसत आहेत',
      Moderate: 'टाळू अधिक दिसू लागला आहे',
      Severe: 'प्रगत टप्प्यातील केसगळती',
      Unknown: 'टाळू दिसत आहे',
    },
    parameterLabels: {
      crownDensity: 'केसांची घनता',
      partitionWidth: 'भांगाची रुंदी',
      scalpVisibility: 'दिसणारी टाळू',
    },
    descriptions: {
      Female: {
        Normal: 'तुमच्या केसांची घनता चांगली आहे, डोक्याची त्वचा दिसत नाही आणि केस पातळ होण्याची लक्षणेही नाहीत. केस निरोगी ठेवण्यासाठी ही योग्य वेळ आहे — योग्य हेअर केअर रूटीनमुळे केस अनेक वर्षे असेच राहण्यास मदत होऊ शकते.',
        Mild: 'तुमचा भांग थोडा रुंद होत आहे — हे केस पातळ होण्याचे सुरुवातीचे लक्षण आहे. या टप्प्यावर केस गळणे थांबवून सुधारणा करणे सर्वात सोपे आहे. आत्ताच ट्रीटमेंट सुरू करा!',
        Moderate: 'तुमचा भांग बराच रुंद होत आहे आणि तो हेअरलाइन व डोक्याच्या वरच्या भागाकडे वाढत आहे. हे आणखी वाढू नये म्हणून आत्ताच ट्रीटमेंट सुरू करा.',
        Severe: 'भांग आणि डोक्याच्या वरच्या भागात डोक्याची त्वचा बरीच दिसत आहे. या टप्प्यावर सुधारणा थोडी कठीण आहे, पण नियमित ट्रीटमेंटमुळे हे आणखी वाढण्याचा वेग कमी होऊ शकतो.',
        Unknown: 'तुमच्या भांगाजवळ डोक्याची त्वचा दिसत आहे — हे केस पातळ होण्याचे लक्षण आहे. ट्रीटमेंट न घेतल्यास हे लवकर वाढू शकते. ते थांबवण्यासाठी आत्ताच ट्रीटमेंट सुरू करा!',
      },
      Male: {
        Normal: 'डोक्याच्या वरच्या भागात आणि हेअरलाइनवर केसांची घनता चांगली आहे. डोक्याची त्वचा दिसत नाही आणि केस पातळ होण्याची लक्षणेही नाहीत. योग्य हेअर केअर रूटीन केस अनेक वर्षे असेच ठेवण्यास मदत करू शकते.',
        Mild: 'डोक्याच्या वरच्या भागात थोडं पातळपण दिसत आहे — हे केस गळण्याचं सुरुवातीचं लक्षण आहे. या टप्प्यावर सुधारणा सर्वात सोपी आहे. आत्ताच ट्रीटमेंट सुरू करा!',
        Moderate: 'डोक्याच्या वरच्या भागातील पातळपण आता हेअरलाइनपर्यंत वाढत आहे. हे आणखी वाढू नये म्हणून आत्ताच ट्रीटमेंट सुरू करा.',
        Severe: 'डोक्याच्या वरच्या भागात आणि हेअरलाइनवर डोक्याची त्वचा स्पष्ट दिसत आहे. या टप्प्यावर सुधारणा थोडी कठीण आहे, पण नियमित ट्रीटमेंटमुळे हे वाढण्याचा वेग कमी होऊ शकतो.',
        Unknown: 'डोक्याच्या वरच्या भागात आणि पुढे डोक्याची त्वचा दिसत आहे — हे केस गळण्याचं लक्षण आहे. ट्रीटमेंट न घेतल्यास हे लवकर वाढू शकते. ते थांबवण्यासाठी आत्ताच ट्रीटमेंट सुरू करा!',
      },
    },
    noDetection: {
      title: 'तुमचा टाळू ओळखता आला नाही',
      reasonsHeading: 'संभाव्य कारणे:',
      reasons: [
        'डोक्याचा वरचा भाग पूर्णपणे फोटोमध्ये नाही',
        'फोटो धूसर किंवा स्पष्ट नाही',
        'प्रकाश खूप कमी किंवा खूप जास्त आहे',
      ],
    },
    hairFrontDetected: {
      title: 'केसांचा समोरचा दृश्य मिळाला',
      description: 'आम्हाला समोरून घेतलेली फोटो मिळाली आहे. टाळूच्या आकलनासाठी कृपया डोक्याच्या वरच्या भागाचा दृश्य देऊन फोटो पुन्हा घ्या.',
    },
  },
  te: {
    titles: {
      Normal: 'ప్రస్తుతం జుట్టు రాలే లక్షణాలు లేవు',
      Mild: 'ప్రారంభ దశ జుట్టు రాలడం గుర్తించబడింది',
      Moderate: 'తల చర్మం ఎక్కువగా కనిపిస్తోంది',
      Severe: 'ముదిరిన దశలో జుట్టు రాలడం',
      Unknown: 'తల చర్మం కనిపిస్తోంది',
    },
    parameterLabels: {
      crownDensity: 'జుట్టు సాంద్రత',
      partitionWidth: 'పాపిడి వెడల్పు',
      scalpVisibility: 'కనిపించే తల చర్మం',
    },
    descriptions: {
      Female: {
        Normal: 'మీ జుట్టు సాంద్రత బాగుంది, తల చర్మం కనిపించడం లేదు మరియు జుట్టు పలుచబడుతున్న సంకేతాలు కూడా లేవు. జుట్టును ఆరోగ్యంగా ఉంచుకోవడానికి ఇదే సరైన సమయం — సరైన హెయిర్ కేర్ రొటీన్ మీ జుట్టును సంవత్సరాల పాటు ఇలాగే ఉంచడంలో సహాయపడుతుంది.',
        Mild: 'మీ పాపిడి కొద్దిగా వెడల్పవుతోంది — ఇది జుట్టు పలుచబడటానికి మొదటి సంకేతం. ఈ దశలో జుట్టు రాలడాన్ని ఆపి మెరుగుపరచడం చాలా సులభం. ఇప్పుడే ట్రీట్‌మెంట్ ప్రారంభించండి!',
        Moderate: 'మీ పాపిడి స్పష్టంగా వెడల్పవుతోంది, హెయిర్‌లైన్ మరియు తల పైభాగం వైపు విస్తరిస్తోంది. ఇది మరింత పెరగకుండా ఇప్పుడే ట్రీట్‌మెంట్ ప్రారంభించండి.',
        Severe: 'పాపిడి మరియు తల పైభాగంలో తల చర్మం ఎక్కువగా కనిపిస్తోంది. ఈ దశలో మెరుగుపరచడం కొంచెం కష్టం, కానీ క్రమం తప్పకుండా ట్రీట్‌మెంట్ తీసుకుంటే ఇది మరింత పెరగడాన్ని నెమ్మదించవచ్చు.',
        Unknown: 'మీ పాపిడి వెంట తల చర్మం కనిపిస్తోంది — ఇది జుట్టు పలుచబడటానికి సంకేతం. ట్రీట్‌మెంట్ లేకపోతే ఇది త్వరగా పెరగవచ్చు. దీన్ని ఆపడానికి ఇప్పుడే ట్రీట్‌మెంట్ ప్రారంభించండి!',
      },
      Male: {
        Normal: 'తల పైభాగం మరియు హెయిర్‌లైన్ వద్ద జుట్టు సాంద్రత బాగుంది. తల చర్మం కనిపించడం లేదు, జుట్టు పలుచబడుతున్న సంకేతాలు కూడా లేవు. సరైన హెయిర్ కేర్ రొటీన్ మీ జుట్టును సంవత్సరాల పాటు ఇలాగే ఉంచడంలో సహాయపడుతుంది.',
        Mild: 'తల పైభాగంలో స్వల్ప పలుచదనం కనిపిస్తోంది — ఇది జుట్టు రాలడానికి ప్రారంభ సంకేతం. ఈ దశలో మెరుగుపరచడం చాలా సులభం. ఇప్పుడే ట్రీట్‌మెంట్ ప్రారంభించండి!',
        Moderate: 'తల పైభాగంలోని పలుచదనం ఇప్పుడు హెయిర్‌లైన్ వరకు విస్తరిస్తోంది. ఇది మరింత పెరగకుండా ఇప్పుడే ట్రీట్‌మెంట్ ప్రారంభించండి.',
        Severe: 'తల పైభాగం మరియు హెయిర్‌లైన్ వద్ద తల చర్మం స్పష్టంగా కనిపిస్తోంది. ఈ దశలో మెరుగుపరచడం కొంచెం కష్టం, కానీ క్రమం తప్పకుండా ట్రీట్‌మెంట్ తీసుకుంటే ఇది మరింత పెరగడాన్ని నెమ్మదించవచ్చు.',
        Unknown: 'తల పైభాగం మరియు ముందు భాగంలో తల చర్మం కనిపిస్తోంది — ఇది జుట్టు రాలడానికి సంకేతం. ట్రీట్‌మెంట్ లేకపోతే ఇది త్వరగా పెరగవచ్చు. దీన్ని ఆపడానికి ఇప్పుడే ట్రీట్‌మెంట్ ప్రారంభించండి!',
      },
    },
    noDetection: {
      title: 'మీ తల చర్మాన్ని సరిగా గుర్తించలేకపోయాము',
      reasonsHeading: 'ఇది జరగడానికి కారణాలు:',
      reasons: [
        'తల పైభాగం పూర్తిగా ఫ్రేమ్‌లో లేదు',
        'ఫోటో మసకగా లేదా స్పష్టంగా లేదు',
        'వెలుతురు చాలా తక్కువగా లేదా చాలా ఎక్కువగా ఉంది',
      ],
    },
    hairFrontDetected: {
      title: 'జుట్టు ముందు వైపు దృశ్యం తీయబడింది',
      description: 'మాకు ముందు నుండి తీసిన ఫోటో అందింది. తల చర్మ అంచనా కోసం దయచేసి మీ తల పైభాగం వైపు ఫోటో మళ్లీ తీయండి.',
    },
  },
  kn: {
    titles: {
      Normal: 'ಇನ್ನೂ ಕೂದಲು ಉದುರುವ ಲಕ್ಷಣಗಳಿಲ್ಲ',
      Mild: 'ಆರಂಭಿಕ ಹಂತದ ಕೂದಲು ಉದುರುವಿಕೆ ಕಂಡುಬಂದಿದೆ',
      Moderate: 'ತಲೆಚರ್ಮ ಹೆಚ್ಚು ಕಾಣಿಸುತ್ತಿದೆ',
      Severe: 'ಮುನ್ನಡೆದ ಹಂತದ ಕೂದಲು ಉದುರುವಿಕೆ',
      Unknown: 'ತಲೆಚರ್ಮ ಕಾಣಿಸುತ್ತಿದೆ',
    },
    parameterLabels: {
      crownDensity: 'ಕೂದಲಿನ ಸಾಂದ್ರತೆ',
      partitionWidth: 'ಸಿಂಧಿಯ ಅಗಲ',
      scalpVisibility: 'ಕಾಣುವ ತಲೆ ಚರ್ಮ',
    },
    descriptions: {
      Female: {
        Normal: 'ನಿಮ್ಮ ಕೂದಲಿನ ಸಾಂದ್ರತೆ ಚೆನ್ನಾಗಿದೆ, ತಲೆಯ ಚರ್ಮ ಕಾಣಿಸುತ್ತಿಲ್ಲ ಮತ್ತು ಕೂದಲು ತೆಳುವಾಗುವ ಲಕ್ಷಣಗಳೂ ಇಲ್ಲ. ಕೂದಲನ್ನು ಆರೋಗ್ಯವಾಗಿಡಲು ಇದೇ ಸರಿಯಾದ ಸಮಯ — ಸರಿಯಾದ ಹೇರ್ ಕೇರ್ ರೂಟೀನ್ ನಿಮ್ಮ ಕೂದಲನ್ನು ಹಲವು ವರ್ಷಗಳವರೆಗೆ ಹೀಗೆಯೇ ಇರಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ.',
        Mild: 'ನಿಮ್ಮ ಸಿಂಧಿ ಸ್ವಲ್ಪ ಅಗಲವಾಗುತ್ತಿದೆ — ಇದು ಕೂದಲು ತೆಳುವಾಗುವ ಆರಂಭಿಕ ಲಕ್ಷಣ. ಈ ಹಂತದಲ್ಲಿ ಕೂದಲು ಉದುರುವುದನ್ನು ತಡೆದು ಸುಧಾರಿಸುವುದು ತುಂಬಾ ಸುಲಭ. ಈಗಲೇ ಟ್ರೀಟ್‌ಮೆಂಟ್ ಪ್ರಾರಂಭಿಸಿ!',
        Moderate: 'ನಿಮ್ಮ ಸಿಂಧಿ ಸ್ಪಷ್ಟವಾಗಿ ಅಗಲವಾಗುತ್ತಿದ್ದು, ಹೇರ್‌ಲೈನ್ ಮತ್ತು ತಲೆಯ ಮೇಲ್ಭಾಗದ ಕಡೆಗೆ ವಿಸ್ತರಿಸುತ್ತಿದೆ. ಇದು ಇನ್ನಷ್ಟು ಹೆಚ್ಚಾಗದಂತೆ ಈಗಲೇ ಟ್ರೀಟ್‌ಮೆಂಟ್ ಪ್ರಾರಂಭಿಸಿ.',
        Severe: 'ಸಿಂಧಿ ಮತ್ತು ತಲೆಯ ಮೇಲ್ಭಾಗದಲ್ಲಿ ತಲೆಯ ಚರ್ಮ ಹೆಚ್ಚು ಕಾಣಿಸುತ್ತಿದೆ. ಈ ಹಂತದಲ್ಲಿ ಸುಧಾರಿಸುವುದು ಸ್ವಲ್ಪ ಕಷ್ಟ, ಆದರೆ ನಿಯಮಿತ ಟ್ರೀಟ್‌ಮೆಂಟ್ ಇದನ್ನು ಇನ್ನಷ್ಟು ಹೆಚ್ಚಾಗುವುದನ್ನು ನಿಧಾನಗೊಳಿಸಬಹುದು.',
        Unknown: 'ನಿಮ್ಮ ಸಿಂಧಿಯ ಬಳಿ ತಲೆಯ ಚರ್ಮ ಕಾಣಿಸುತ್ತಿದೆ — ಇದು ಕೂದಲು ತೆಳುವಾಗುವ ಲಕ್ಷಣ. ಟ್ರೀಟ್‌ಮೆಂಟ್ ಇಲ್ಲದಿದ್ದರೆ ಇದು ಬೇಗ ಹೆಚ್ಚಾಗಬಹುದು. ಇದನ್ನು ತಡೆಯಲು ಈಗಲೇ ಟ್ರೀಟ್‌ಮೆಂಟ್ ಪ್ರಾರಂಭಿಸಿ!',
      },
      Male: {
        Normal: 'ತಲೆಯ ಮೇಲ್ಭಾಗ ಮತ್ತು ಹೇರ್‌ಲೈನ್‌ನಲ್ಲಿ ಕೂದಲಿನ ಸಾಂದ್ರತೆ ಚೆನ್ನಾಗಿದೆ. ತಲೆಯ ಚರ್ಮ ಕಾಣಿಸುತ್ತಿಲ್ಲ ಮತ್ತು ಕೂದಲು ತೆಳುವಾಗುವ ಲಕ್ಷಣಗಳೂ ಇಲ್ಲ. ಸರಿಯಾದ ಹೇರ್ ಕೇರ್ ರೂಟೀನ್ ನಿಮ್ಮ ಕೂದಲನ್ನು ಹಲವು ವರ್ಷಗಳವರೆಗೆ ಹೀಗೆಯೇ ಇರಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ.',
        Mild: 'ತಲೆಯ ಮೇಲ್ಭಾಗದಲ್ಲಿ ಸ್ವಲ್ಪ ತೆಳುವಾಗಿರುವುದು ಕಾಣುತ್ತಿದೆ — ಇದು ಕೂದಲು ಉದುರುವ ಆರಂಭಿಕ ಲಕ್ಷಣ. ಈ ಹಂತದಲ್ಲಿ ಸುಧಾರಿಸುವುದು ತುಂಬಾ ಸುಲಭ. ಈಗಲೇ ಟ್ರೀಟ್‌ಮೆಂಟ್ ಪ್ರಾರಂಭಿಸಿ!',
        Moderate: 'ತಲೆಯ ಮೇಲ್ಭಾಗದ ತೆಳುವಾಗಿರುವುದು ಈಗ ಹೇರ್‌ಲೈನ್ ವರೆಗೆ ವಿಸ್ತರಿಸುತ್ತಿದೆ. ಇದು ಇನ್ನಷ್ಟು ಹೆಚ್ಚಾಗದಂತೆ ಈಗಲೇ ಟ್ರೀಟ್‌ಮೆಂಟ್ ಪ್ರಾರಂಭಿಸಿ.',
        Severe: 'ತಲೆಯ ಮೇಲ್ಭಾಗ ಮತ್ತು ಹೇರ್‌ಲೈನ್‌ನಲ್ಲಿ ತಲೆಯ ಚರ್ಮ ಸ್ಪಷ್ಟವಾಗಿ ಕಾಣುತ್ತಿದೆ. ಈ ಹಂತದಲ್ಲಿ ಸುಧಾರಿಸುವುದು ಸ್ವಲ್ಪ ಕಷ್ಟ, ಆದರೆ ನಿಯಮಿತ ಟ್ರೀಟ್‌ಮೆಂಟ್ ಇದನ್ನು ಇನ್ನಷ್ಟು ಹೆಚ್ಚಾಗುವುದನ್ನು ನಿಧಾನಗೊಳಿಸಬಹುದು.',
        Unknown: 'ತಲೆಯ ಮೇಲ್ಭಾಗ ಮತ್ತು ಮುಂಭಾಗದಲ್ಲಿ ತಲೆಯ ಚರ್ಮ ಕಾಣಿಸುತ್ತಿದೆ — ಇದು ಕೂದಲು ಉದುರುವ ಲಕ್ಷಣ. ಟ್ರೀಟ್‌ಮೆಂಟ್ ಇಲ್ಲದಿದ್ದರೆ ಇದು ಬೇಗ ಹೆಚ್ಚಾಗಬಹುದು. ಇದನ್ನು ತಡೆಯಲು ಈಗಲೇ ಟ್ರೀಟ್‌ಮೆಂಟ್ ಪ್ರಾರಂಭಿಸಿ!',
      },
    },
    noDetection: {
      title: 'ನಿಮ್ಮ ತಲೆಚರ್ಮವನ್ನು ಸರಿಯಾಗಿ ಗುರುತಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ',
      reasonsHeading: 'ಸಂಭವ್ಯ ಕಾರಣಗಳು:',
      reasons: [
        'ತಲೆಯ ಮೇಲ್ಭಾಗ ಸಂಪೂರ್ಣವಾಗಿ ಫ್ರೇಮ್‌ನಲ್ಲಿ ಇಲ್ಲ',
        'ಫೋಟೋ ಮಸುಕಾಗಿದೆ ಅಥವಾ ಸ್ಪಷ್ಟವಾಗಿಲ್ಲ',
        'ಬೆಳಕು ತುಂಬಾ ಕಡಿಮೆ ಅಥವಾ ತುಂಬಾ ಹೆಚ್ಚು ಇದೆ',
      ],
    },
    hairFrontDetected: {
      title: 'ಮುಂಭಾಗದ ಕೂದಲಿನ ಫೋಟೋ ಸ್ವೀಕರಿಸಲಾಗಿದೆ',
      description: 'ನಮಗೆ ಮುಂಭಾಗದಿಂದ ತೆಗೆದ ಫೋಟೋ ಸಿಕ್ಕಿದೆ. ತಲೆಚರ್ಮದ ಅಂಚನೆಗಾಗಿ ದಯವಿಟ್ಟು ನಿಮ್ಮ ತಲೆಯ ಮೇಲ್ಭಾಗದ ಫೋಟೋ ಮತ್ತೆ ತೆಗೆಯಿರಿ.',
    },
  },
  ta: {
    titles: {
      Normal: 'இன்னும் முடி உதிர்வுக்கான அறிகுறிகள் இல்லை',
      Mild: 'ஆரம்ப நிலை முடி உதிர்வு கண்டறியப்பட்டது',
      Moderate: 'தலைச்சருமம் அதிகமாக தெரிகிறது',
      Severe: 'முன்னேறிய நிலை முடி உதிர்வு',
      Unknown: 'தலைச்சருமம் தெரிகிறது',
    },
    parameterLabels: {
      crownDensity: 'முடி அடர்த்தி',
      partitionWidth: 'வகிடு அகலம்',
      scalpVisibility: 'தெரியும் தலை தோல்',
    },
    descriptions: {
      Female: {
        Normal: 'உங்கள் முடியின் அடர்த்தி நன்றாக உள்ளது, தலை தோல் தெரியவில்லை, முடி மெலிவதற்கான அறிகுறிகளும் இல்லை. முடியை ஆரோக்கியமாக வைத்திருக்க இதுவே சரியான நேரம் — சரியான ஹேர் கேர் ரூட்டீன் உங்கள் முடியை பல ஆண்டுகள் இப்படியே வைத்திருக்க உதவும்.',
        Mild: 'உங்கள் வகிடு சற்று அகலமாகியுள்ளது — இது முடி மெலிவதற்கான ஆரம்ப அறிகுறி. இந்த நிலையில் முடி உதிர்வைக் கட்டுப்படுத்தி மேம்படுத்துவது மிகவும் எளிது. இப்போதே ட்ரீட்மென்ட் தொடங்குங்கள்!',
        Moderate: 'உங்கள் வகிடு தெளிவாக அகலமாகி, ஹேர்லைன் மற்றும் தலையின் மேல் பகுதியை நோக்கி நீள்கிறது. இது மேலும் அதிகரிக்காமல் இருக்க இப்போதே ட்ரீட்மென்ட் தொடங்குங்கள்.',
        Severe: 'வகிடு மற்றும் தலையின் மேல் பகுதியில் தலை தோல் அதிகமாகத் தெரிகிறது. இந்த நிலையில் மேம்படுத்துவது சற்று கடினம், ஆனால் தொடர்ந்து ட்ரீட்மென்ட் எடுத்தால் இது மேலும் அதிகரிப்பதை மெதுவாக்கலாம்.',
        Unknown: 'உங்கள் வகிடு பகுதியில் தலை தோல் தெரிகிறது — இது முடி மெலிவதற்கான அறிகுறி. ட்ரீட்மென்ட் இல்லாமல் இது விரைவில் அதிகரிக்கலாம். இதைத் தடுக்க இப்போதே ட்ரீட்மென்ட் தொடங்குங்கள்!',
      },
      Male: {
        Normal: 'தலையின் மேல் பகுதி மற்றும் ஹேர்லைனில் முடியின் அடர்த்தி நன்றாக உள்ளது. தலை தோல் தெரியவில்லை, முடி மெலிவதற்கான அறிகுறிகளும் இல்லை. சரியான ஹேர் கேர் ரூட்டீன் உங்கள் முடியை பல ஆண்டுகள் இப்படியே வைத்திருக்க உதவும்.',
        Mild: 'தலையின் மேல் பகுதியில் லேசான மெலிவு தெரிகிறது — இது முடி உதிர்வின் ஆரம்ப அறிகுறி. இந்த நிலையில் மேம்படுத்துவது மிகவும் எளிது. இப்போதே ட்ரீட்மென்ட் தொடங்குங்கள்!',
        Moderate: 'தலையின் மேல் பகுதியிலுள்ள மெலிவு இப்போது ஹேர்லைன் வரை பரவி வருகிறது. இது மேலும் அதிகரிக்காமல் இருக்க இப்போதே ட்ரீட்மென்ட் தொடங்குங்கள்.',
        Severe: 'தலையின் மேல் பகுதி மற்றும் ஹேர்லைனில் தலை தோல் தெளிவாக தெரிகிறது. இந்த நிலையில் மேம்படுத்துவது சற்று கடினம், ஆனால் தொடர்ந்து ட்ரீட்மென்ட் எடுத்தால் இது மேலும் அதிகரிப்பதை மெதுவாக்கலாம்.',
        Unknown: 'தலையின் மேல் பகுதியிலும் முன்புறத்திலும் தலை தோல் தெரிகிறது — இது முடி உதிர்வதற்கான அறிகுறி. ட்ரீட்மென்ட் இல்லாமல் இது விரைவில் அதிகரிக்கலாம். இதைத் தடுக்க இப்போதே ட்ரீட்மென்ட் தொடங்குங்கள்!',
      },
    },
    noDetection: {
      title: 'உங்கள் தலைச்சருமத்தை சரியாக கண்டறிய முடியவில்லை',
      reasonsHeading: 'இதற்கான காரணங்கள்:',
      reasons: [
        'தலையின் மேற்பகுதி முழுமையாக படத்தில் இல்லை',
        'புகைப்படம் மங்கலாக அல்லது தெளிவாக இல்லை',
        'ஒளி மிகவும் குறைவாக அல்லது மிகவும் அதிகமாக உள்ளது',
      ],
    },
    hairFrontDetected: {
      title: 'முன்பக்க முடி படம் பெறப்பட்டது',
      description: 'முன்பக்கத்திலிருந்து எடுக்கப்பட்ட புகைப்படத்தை பெற்றோம். தலைச்சரும மதிப்பீட்டிற்கு தயவுசெய்து உங்கள் தலையின் மேற்பகுதி படத்தை மீண்டும் எடுக்கவும்.',
    },
  },
  bn: {
    titles: {
      Normal: 'এখনও চুল পড়ার কোনো লক্ষণ নেই',
      Mild: 'প্রাথমিক পর্যায়ের চুল পড়া ধরা পড়েছে',
      Moderate: 'মাথার ত্বক আরও বেশি দেখা যাচ্ছে',
      Severe: 'উন্নত পর্যায়ের চুল পড়া',
      Unknown: 'মাথার ত্বক দেখা যাচ্ছে',
    },
    parameterLabels: {
      crownDensity: 'চুলের ঘনত্ব',
      partitionWidth: 'সিঁথির চওড়া',
      scalpVisibility: 'দৃশ্যমান মাথার ত্বক',
    },
    descriptions: {
      Female: {
        Normal: 'আপনার চুলের ঘনত্ব ভালো, মাথার ত্বক দেখা যাচ্ছে না এবং চুল পাতলা হওয়ার লক্ষণও নেই। চুল ভালো রাখার এটাই সঠিক সময় — সঠিক হেয়ার কেয়ার রুটিন আপনার চুলকে বহু বছর এমনই রাখতে সাহায্য করতে পারে।',
        Mild: 'আপনার সিঁথি একটু চওড়া হচ্ছে — এটি চুল পাতলা হওয়ার প্রথম লক্ষণ। এই পর্যায়ে চুল পড়া আটকানো এবং উন্নতি করা সবচেয়ে সহজ। এখনই ট্রিটমেন্ট শুরু করুন!',
        Moderate: 'আপনার সিঁথি বেশ চওড়া হচ্ছে এবং হেয়ারলাইন ও মাথার উপরের অংশের দিকে ছড়িয়ে পড়ছে। এটি আরও বাড়ার আগেই এখনই ট্রিটমেন্ট শুরু করুন।',
        Severe: 'সিঁথি এবং মাথার উপরের অংশে মাথার ত্বক বেশ স্পষ্ট দেখা যাচ্ছে। এই পর্যায়ে উন্নতি করা কিছুটা কঠিন, তবে নিয়মিত ট্রিটমেন্ট এটি আরও বাড়ার গতি কমাতে পারে।',
        Unknown: 'আপনার সিঁথির কাছে মাথার ত্বক দেখা যাচ্ছে — এটি চুল পাতলা হওয়ার লক্ষণ। ট্রিটমেন্ট না নিলে এটি দ্রুত বাড়তে পারে। এটি আটকাতে এখনই ট্রিটমেন্ট শুরু করুন!',
      },
      Male: {
        Normal: 'মাথার উপরের অংশ ও হেয়ারলাইনে চুলের ঘনত্ব ভালো। মাথার ত্বক দেখা যাচ্ছে না এবং চুল পাতলা হওয়ার লক্ষণও নেই। সঠিক হেয়ার কেয়ার রুটিন আপনার চুলকে বহু বছর এমনই রাখতে সাহায্য করতে পারে।',
        Mild: 'মাথার উপরের অংশে হালকা পাতলা ভাব দেখা যাচ্ছে — এটি চুল পড়ার প্রাথমিক লক্ষণ। এই পর্যায়ে উন্নতি করা সবচেয়ে সহজ। এখনই ট্রিটমেন্ট শুরু করুন!',
        Moderate: 'মাথার উপরের অংশের পাতলা ভাব এখন হেয়ারলাইন পর্যন্ত ছড়িয়ে পড়ছে। এটি আরও বাড়ার আগেই এখনই ট্রিটমেন্ট শুরু করুন।',
        Severe: 'মাথার উপরের অংশ ও হেয়ারলাইনে মাথার ত্বক স্পষ্ট দেখা যাচ্ছে। এই পর্যায়ে উন্নতি করা কিছুটা কঠিন, তবে নিয়মিত ট্রিটমেন্ট এটি আরও বাড়ার গতি কমাতে পারে।',
        Unknown: 'মাথার উপরের অংশ ও সামনের দিকে মাথার ত্বক দেখা যাচ্ছে — এটি চুল পড়ার লক্ষণ। ট্রিটমেন্ট না নিলে এটি দ্রুত বাড়তে পারে। এটি আটকাতে এখনই ট্রিটমেন্ট শুরু করুন!',
      },
    },
    noDetection: {
      title: 'আপনার মাথার ত্বক সঠিকভাবে শনাক্ত করা যায়নি',
      reasonsHeading: 'সম্ভাব্য কারণ:',
      reasons: [
        'মাথার উপরের অংশ পুরোপুরি ছবিতে নেই',
        'ছবিটি ঝাপসা বা পরিষ্কার নয়',
        'আলো খুব কম বা খুব বেশি',
      ],
    },
    hairFrontDetected: {
      title: 'সামনের দিকের চুলের ছবি পাওয়া গেছে',
      description: 'আমরা সামনের দিক থেকে তোলা একটি ছবি পেয়েছি। মাথার ত্বকের মূল্যায়নের জন্য অনুগ্রহ করে আপনার মাথার উপরের অংশের ছবি আবার তুলুন।',
    },
  },
};
